import * as moment from 'moment-timezone';

export const getNotDeletedItems = (items, queryName) => {
    if (items && items.data && items.data[queryName]) {
        items = items.data[queryName].items || [];
    } else {
        items = [];
    }
    return items.filter(i => i._deleted == null || !i._deleted);
}

export const getDataFromResponse = (response, queryName) => {
    let data = {}
    if (response && response.data && response.data[queryName]) {
        data = response.data[queryName] || {};
    }
    return data;
}

export const cleanUpData = (item) => {
    let modelData = { ...item };
    delete modelData._deleted;
    delete modelData._toDelete;
    delete modelData._lastChangedAt;
    delete modelData.__typename;
    delete modelData.createdAt;
    delete modelData.updatedAt;
    delete modelData.owner;
    return modelData;
}

export const errorHandler = (error, message = "Api Error") => {
    console.log(message, error);
}

export const toLocaleTime = (utcTime, format = "DD/MM/YYYY") => {
    const time = moment.utc(utcTime);
    return time.local().format(format);
}

export const getCounterTypeByCargoType = (cargoType) => {
    return `${cargoType}_TRANSPORTATION`;
}
